import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Intro from './Views/Intro';
import BackupCode from './Views/BackupCode';
import EnterVerificationCode from './Views/EnterVerificationCode';
import CaptureQRCode from './Views/CaptureQRCode';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const stepMap = {
  intro: { name: 'intro', component: Intro },
  captureQRCode: { name: 'captureQRCode', component: CaptureQRCode },
  backupCode: { name: 'backupCode', component: BackupCode },
  enterVerificationCode: { name: 'enterVerificationCode', component: EnterVerificationCode },
};

const Layout = ({
  className,
  classes,
}) => {
  const [stepName, setStepName] = React.useState(stepMap.intro.name);
  const Component = stepMap[stepName].component;
  const changeState = (step) => {
    const { name } = step;
    if (stepMap[name]) {
      setStepName(name);
    } else {
      throw new Error(`Invalid state name: ${name}. Must be one of:${Object.keys(stepMap)}`);
    }
  };

  return (
    <Box className={classNames(classes.root, className)}>
      <Component
        changeState={changeState}
      />
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
